/* eslint-ignore */
// @ts-nocheck
import React, {
  useRef,
  useMemo,
  useState,
  useCallback,
  useEffect,
} from 'react';
import theme from '~/styles/theme';

import { Container, ErrorText, LabelText } from './styles';

const TextArea = ({
  LeadingIcon,
  TrailingIcon,
  label,
  errorMessage,
  name,
  errorCondition,
  placeholder,
  borderHighlightColor,
  disabled,
  iconColor,
  ...rest
}) => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isErrored, setIsErrored] = useState(false);
  const [isLabelActivated, setIsLabelActivated] = useState(false);

  useEffect(() => {
    setIsErrored(!!errorCondition);
  }, [errorCondition]);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.addEventListener('blur', () => {
        setIsFocused(false);
      });
      inputRef.current.addEventListener('focus', () => {
        setIsFocused(true);
      });
    }
  }, [inputRef]);

  useEffect(() => {
    const inputValue = inputRef ? inputRef.current.value || '' : '';
    if (isFocused || inputValue.length > 0) setIsLabelActivated(true);
    else setIsLabelActivated(false);
  }, [isFocused]);

  const randomId = useMemo(() => {
    return `${label.replace(/\s/g, '')}-${Math.floor(Math.random() * 100)}`;
  }, [label]);

  return (
    <>
      <Container
        isFocused={isFocused}
        isErrored={isErrored}
        borderHighlightColor={borderHighlightColor || theme.colors.lightBlue}
        iconColor={iconColor || theme.colors.gray}
        disabled={disabled}
      >
        {LeadingIcon && <LeadingIcon />}
        <div>
          <LabelText
            labelActivated={isLabelActivated}
            id={`labelId-${randomId}`}
          >
            {label}
          </LabelText>
          <textarea
            name={name}
            ref={inputRef}
            rows="5"
            aria-labelledby={`labelId-${randomId}`}
            placeholder={label ? '' : placeholder}
            aria-controls={`control-${randomId}`}
            aria-describedby={`control-${randomId}`}
            disabled={disabled}
            {...rest}
          />
        </div>
        {TrailingIcon && <TrailingIcon />}
      </Container>
      {errorMessage && errorCondition && (
        <ErrorText aria-hidden="true" id={`control-${randomId}`}>
          {' '}
          {errorMessage}
        </ErrorText>
      )}
    </>
  );
};

export default TextArea;
